import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import AchievementIcon from "./achievementIcon";

// Shows one toast per newly-unlocked achievement, fed by AuthContext's
// `unlockedQueue` (populated after login/register/profile updates/refresh).
// Mounted once near the root in App.js so it works from any page.
export default function AchievementUnlockPopup() {
  const { unlockedQueue, dismissUnlocked } = useAuth();
  const [visible, setVisible] = useState(false);
  const current = unlockedQueue[0] || null;

  useEffect(() => {
    if (!current) {
      setVisible(false);
      return;
    }
    setVisible(true);
    const showFor = setTimeout(() => setVisible(false), 5000);
    const removeAfterFade = setTimeout(() => dismissUnlocked(), 5400);
    return () => {
      clearTimeout(showFor);
      clearTimeout(removeAfterFade);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current?.key]);

  if (!current) return null;

  return (
    <div
      className="fixed z-[9999] top-4 right-4 left-4 sm:left-auto sm:w-80 pointer-events-none"
      aria-live="polite"
    >
      <div
        className={`pointer-events-auto flex items-center gap-3 rounded-large border border-primary/30 bg-content1 shadow-lg p-3 transition-all duration-300 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
        }`}
        role="status"
      >
        <div className="flex items-center justify-center w-11 h-11 rounded-full bg-primary/15 text-primary shrink-0">
          <AchievementIcon icon={current.icon} size={22} />
        </div>
        <div className="min-w-0">
          <div className="text-tiny font-semibold text-primary uppercase tracking-wide">Achievement unlocked</div>
          <div className="font-semibold text-small truncate">{current.name}</div>
          <div className="text-tiny text-foreground-500 truncate">{current.description}</div>
        </div>
        <button
          type="button"
          aria-label="Dismiss"
          className="ml-auto text-foreground-400 hover:text-foreground-600 text-tiny shrink-0"
          onClick={() => setVisible(false)}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
